import { forwardRef } from 'react';
import classnames from 'classnames';

import { LoaderOutlinedSize16Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LoaderOutlinedSize16';
import { LoaderOutlinedSize24Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LoaderOutlinedSize24';
import { LoaderOutlinedSize32Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LoaderOutlinedSize32';
import { LoaderOutlinedSize48Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LoaderOutlinedSize48';
import { LoaderOutlinedSize64Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LoaderOutlinedSize64';
import { LoaderOutlinedSize96Glyph } from '@hh.ru/magritte-ui-icon/variants/icon/LoaderOutlinedSize96';

import styles from './loader.less';

const LOADER_BY_SIZE = {
    16: LoaderOutlinedSize16Glyph,
    24: LoaderOutlinedSize24Glyph,
    32: LoaderOutlinedSize32Glyph,
    48: LoaderOutlinedSize48Glyph,
    64: LoaderOutlinedSize64Glyph,
    96: LoaderOutlinedSize96Glyph,
};

export const LoaderGlyph = forwardRef<
    SVGSVGElement,
    React.SVGProps<SVGSVGElement> & { size: 16 | 24 | 32 | 48 | 64 | 96 }
>(({ size, ...props }, ref) => {
    const Glyph = LOADER_BY_SIZE[size];
    return <Glyph {...props} className={classnames(props.className, styles.spinner)} ref={ref} />;
});

LoaderGlyph.displayName = 'LoaderGlyph';
